
import { useContext } from "react";
import style from "./ModalInfoPrzerwa.module.css";
import { TechnologyContext } from "context/TechnologyContext";
import { addDostepnoscPapieru } from "./addDostepnoscPapieru";
import { useGant } from "../useGant";
import { addPrzerwaInfo } from "./addPrzerwaInfo";
export default function Zapisz({grupaId,uwagi,oprawa,setShowWindowInfoPrzerwa}) {

      const techContext = useContext(TechnologyContext);
      const grupyWykonanAll = techContext.grupyWykonanAll;
      const setGrupWykonanAll = techContext.setGrupWykonanAll;
        const {refreshGantAll} = useGant();
      
    return (
      <button
        className={style.btn}
        onClick={() => {
          addPrzerwaInfo(grupaId,uwagi,oprawa,refreshGantAll,setShowWindowInfoPrzerwa)
          // setShow(false)
          }}
      >
        Zapisz
      </button>
    );
  }